import React from 'react'
import { FileText, X, CheckCircle, AlertCircle } from 'lucide-react'
import { Tooltip } from 'antd'
import type { VentureDocument } from '../../../services/documents/documentService'
import {
  DocumentListItem,
  DocumentFileName,
  DocumentDeleteButton,
  SpinningLoader,
} from './styles/VentureNodeStyles'

interface VentureDocumentListProps {
  documents: VentureDocument[]
  onDelete: (id: string) => void
}

export const VentureDocumentList = React.memo(
  ({ documents, onDelete }: VentureDocumentListProps) => {
    if (documents.length === 0) return null

    return (
      <div>
        {documents.map((doc) => (
          <DocumentListItem key={doc.id}>
            <FileText size={13} style={{ flexShrink: 0, color: '#3b82f6', opacity: 0.7 }} />
            <DocumentFileName title={doc.file_name}>{doc.file_name}</DocumentFileName>

            {doc.status === 'processing' && (
              <Tooltip title="Processing...">
                <SpinningLoader size={13} />
              </Tooltip>
            )}

            {doc.status === 'ready' && (
              <Tooltip title="Ready">
                <CheckCircle size={13} style={{ flexShrink: 0, color: '#3b82f6' }} />
              </Tooltip>
            )}

            {doc.status === 'error' && (
              <Tooltip title={doc.error_message ?? 'Processing failed'}>
                <AlertCircle
                  size={13}
                  style={{ flexShrink: 0, color: 'var(--color-error, #ff4d4f)' }}
                />
              </Tooltip>
            )}

            <DocumentDeleteButton onClick={() => void onDelete(doc.id)} title="Remove document">
              <X size={12} />
            </DocumentDeleteButton>
          </DocumentListItem>
        ))}
      </div>
    )
  }
)

VentureDocumentList.displayName = 'VentureDocumentList'
